/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateStripeCheckoutSessionAddressPayload } from './CreateStripeCheckoutSessionAddressPayload';
export type CreateStripeCheckoutSessionPayload = {
    start: string;
    eventCategoryId: number;
    address?: CreateStripeCheckoutSessionAddressPayload;
    onlinePaymentMethod?: CreateStripeCheckoutSessionPayload.onlinePaymentMethod;
    returnUrl?: string;
};
export namespace CreateStripeCheckoutSessionPayload {
    export enum onlinePaymentMethod {
        CARD = 'card',
        SEPA = 'sepa',
        PAYPAL = 'paypal',
        KLARNA = 'klarna',
        BANK_TRANSFER = 'bank_transfer',
        APPLE_PAY = 'apple_pay',
        GOOGLE_PAY = 'google_pay',
    }
}

